// Sticky mobile add-to-cart: show the bar only once the main ATC is scrolled out of view.
(function () {
  var bar = document.querySelector('[data-infy-sticky-atc]');
  if (!bar) return;

  var target = document.getElementById(bar.getAttribute('data-watch'));
  if (!target || !('IntersectionObserver' in window)) return;

  new IntersectionObserver(
    function (entries) {
      bar.classList.toggle('infy-sticky-atc--visible', !entries[0].isIntersecting);
    },
    { rootMargin: '0px 0px -80px 0px' }
  ).observe(target);

  // Keep price + button state in sync with the selected variant. The shared
  // form already submits the right variant; this is display-only sync.
  var sectionId = bar.getAttribute('data-section');
  if (!sectionId || typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    if (!event.data || event.data.sectionId !== sectionId) return;

    var priceEl = bar.querySelector('.infy-sticky-atc__price');
    var mainPrice = document.getElementById('price-' + sectionId);
    if (priceEl && mainPrice) {
      var onSale = mainPrice.querySelector('.price--on-sale');
      var item = onSale
        ? mainPrice.querySelector('.price__sale .price-item--sale')
        : mainPrice.querySelector('.price__regular .price-item--regular');
      if (item) priceEl.textContent = item.textContent.trim();
    }

    var button = bar.querySelector('.infy-sticky-atc__button');
    if (button && event.data.variant) button.disabled = !event.data.variant.available;
    // ponytail: unavailable option combos (variant=null) publish no event; the
    // shared form still blocks submit, only the sticky visual state lags there.
  });
})();
